

/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

// Close the cart drawer with the same animation as the X/overlay
(function () {
  function closeCartDrawerWithAnimation(next) {
    const drawer = document.querySelector('cart-drawer.js-cart-drawer, cart-drawer');
    if (!drawer) { next && next(); return; }

    // Use the theme's native close button (keeps logic/animation identical)
    const closeBtn = drawer.querySelector('.js-close-drawer');
    if (closeBtn) {
      closeBtn.click();
    } else {
      // Fallback if needed
      drawer.removeAttribute('open');
      drawer.classList.remove('is-open');
    }

    // Sync overlay state with your CSS classes
    const overlay = document.querySelector('.overlay, .drawer-backdrop');
    if (overlay) overlay.classList.remove('is-visible');

    // Derive transition duration from CSS (your .drawer has 0.8s)
    const cs = getComputedStyle(drawer);
    const dur = (cs.transitionDuration || '0s')
      .split(',')
      .map(s => parseFloat(s) * (s.includes('ms') ? 1 : 1000))
      .filter(n => !isNaN(n))
      .reduce((a, b) => Math.max(a, b), 0) || 800;

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      drawer.removeEventListener('transitionend', onEnd);
      next && next();
    };
    const onEnd = (e) => {
      if (e.target === drawer) finish();
    };

    drawer.addEventListener('transitionend', onEnd, { once: true });
    setTimeout(finish, dur + 50); // safety in case transitionend is missed
  }

  // Intercept the empty-state "CONTINUE SHOPPING" button and just close
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart-drawer__empty-content .button-row__btn');
    if (!btn) return;

    // prevent navigation — we only want to close smoothly
    e.preventDefault();
    closeCartDrawerWithAnimation();
  });
})();


